var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Site Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.36,48.61H9.22a3.92,3.92,0,0,1-3.93-3.92V10.5A3.92,3.92,0,0,1,9.22,6.58H43a3.91,3.91,0,0,1,3.92,3.92V24.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.29,
    y1: 15.73,
    x2: 46.87,
    y2: 15.73
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.57,42.61A9.67,9.67,0,0,0,53,41.3a10.85,10.85,0,0,0,.26-1.36l3.5-1.49a.7.7,0,0,0,.39-.83l-1.47-5.48a.68.68,0,0,0-.75-.51l-3.78.46a10.64,10.64,0,0,0-2-2l.45-3.77a.73.73,0,0,0-.53-.76l-5.47-1.46a.72.72,0,0,0-.83.4L41.37,28a10.23,10.23,0,0,0-2.68.73l-3-2.29a.71.71,0,0,0-.91.07l-4,4a.7.7,0,0,0-.07.92l2.28,3a11.22,11.22,0,0,0-.45,1.31,10.85,10.85,0,0,0-.26,1.36l-3.49,1.49a.71.71,0,0,0-.4.84L29.82,45a.7.7,0,0,0,.75.52L34.35,45a11,11,0,0,0,1.95,2l-.45,3.76a.71.71,0,0,0,.52.75L41.85,53a.72.72,0,0,0,.83-.4l1.48-3.49a10.16,10.16,0,0,0,2.67-.73l3,2.29a.73.73,0,0,0,.92-.07l4-4a.71.71,0,0,0,.07-.92Zm-11.09.74a5,5,0,1,1,6.07-3.51A5,5,0,0,1,41.48,43.35Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.95,
    y1: 11.14,
    x2: 15.35,
    y2: 11.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.56,27.67a.88.88,0,0,1-.68.76L20,29.36l2.49,3.08a1.51,1.51,0,1,1-2.35,1.9l-2.57-3.19-2,3.9a.91.91,0,0,1-.6.48.8.8,0,0,1-.31,0,.91.91,0,0,1-.79-.72L10.69,21.34a.9.9,0,0,1,1.3-1l12.07,6.43A.9.9,0,0,1,24.56,27.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSettings01);
export default __webpack_public_path__ + "static/media/Site_Settings_01.357627378dd40d117799cad280cc7ebd.svg";
export { ForwardRef as ReactComponent };